module.exports = __webpack_public_path__ + "img/grid-item-kynorelle-02.9634f5d6.webp";